import {useState, useEffect, useRef} from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import MoreDataElement from './MoreDataElement';
import LandingPage from './LandingPage.js';
import Card from './Card.js';

export default function App() {
  const [allMessages, setAllMessages] = useState([])
  const [moreData, setMoreData] = useState(false);
  const [filteredBasicData, setFilteredBasicData] = useState([]);
  const [filters, setFilters] = useState({sortBy: {count:true}, filterBy:'', items:10})
  const [scrolled, setScrolled] = useState(false);
  const divRef = useRef(null);

  useEffect(()=>{
    let newData = allMessages.map(data=>{
      let messageSplit = {};
      data.messages.forEach(o=>{messageSplit[o.sender_name]=messageSplit[o.sender_name]+1|| 1})
      return {
        ...data,
        count: data.messages.length,
        messageSplit,
      }
    })
    let sorted = newData.sort((a,b)=>{
      if(filters.sortBy.count){
        if(a.count > b.count) return -1;
        return 1;
      }else{
        return 0;
      }
    })
    let filtered = sorted.filter(o=>o?.title?.toLowerCase()?.includes(filters.filterBy.toLowerCase()))
    setFilters({...filters, items:10})
    setFilteredBasicData(filtered)


    if(!scrolled && filtered.length>0){
      setScrolled(true)
      divRef.current.scrollIntoView({ behavior: 'smooth' });
    }

  }, [allMessages, filters.sortBy, filters.filterBy])

  return (
    <>
      <LandingPage setAllMessages={setAllMessages}/>

      {allMessages&&
        <div style={{display:'flex'}}>
          <div style={{width:'50%', height:'100vh'}} ref={divRef}>
            <div style={{ padding:'2rem', height:'90%'}}>
              <input
                style={{border: '#EF709D', borderWidth: '1px', borderStyle: 'solid', height: '1.5rem', paddingLeft: '1rem', borderRadius: '1rem'}}
                type="text"
                name="search"
                value={filters.filterBy}
                onChange={(event)=>{setFilters({...filters, filterBy:event.target.value})}}
              />
              <div style={{overflowY:'auto', height:'100%'}}>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={()=>{setFilters({...filters, items:filters.items+10})}}
                  hasMore={filters.items<filteredBasicData.length}
                  loader={<></>}
                  style={{display:'flex', flexWrap: 'wrap'}}
                  useWindow={false}
                >
                {filteredBasicData.slice(0, filters.items).map((data, key)=>
                <Card {...data} key={key} onClick={()=>setMoreData(filteredBasicData[key])}/>
                )}
                </InfiniteScroll>
              </div>
            </div>
            <div style={{textAlign:'center'}}>Made with ❤️ by <a href='http://www.lucolsthoorn.com'>Luc Olsthoorn</a></div>
          </div>
          {!!moreData?(<MoreDataElement data={moreData} close={()=>{setMoreData(false)}}/>):(<></>)}
        </div>
      }
    </>
  );
}
